import React from "react"
import { LazyLoadImage } from "react-lazy-load-image-component"

import { S3Image } from "aws-amplify-react"
const ImageProfile = ({ userInfoImage, width, height, avatar }) => {
	if (
		userInfoImage &&
		userInfoImage !== "-" &&
		userInfoImage !== "/login.png"
	) {
		if (userInfoImage.includes("http")) {
			if (userInfoImage.includes("https://media.licdn")) {
				return (
					<LazyLoadImage
						alt="userInfo"
						src="/login.png"
						width={width}
						height={height}
					/>
				)
			} else {
				return (
					<LazyLoadImage
						alt="userInfo"
						src={userInfoImage}
						width={width}
						height={height}
					/>
				)
			}
		} else {
			return (
				<S3Image
					imgKey={userInfoImage}
					theme={{
						photoImg: { width, height },
					}}
				></S3Image>
			)
		}
	} else {
		return (
			<LazyLoadImage
				alt="userInfo"
				src="/login.png"
				width={width}
				height={height}
			/>
		)
	}
}

export default ImageProfile
